import {RestResource} from '../rest'

import { WORK_ORDER_SERVER } from '../server'
import {athubAxios} from "../../util/athub-axios";

const jobPlanScene = new RestResource({server: WORK_ORDER_SERVER, resource: 'jobplanscene'});
jobPlanScene._maxSequenceUrl = [jobPlanScene.server, jobPlanScene.resource, 'maxSequence'].join('/');
jobPlanScene.getMaxSequence = function(jobPlanId, athubConfig) {
  return athubAxios.get(jobPlanScene._maxSequenceUrl + '?jobPlanId=' + jobPlanId, athubConfig);
};
export default jobPlanScene;